<template>
  <div class="ts-w-full">
        <a-select
					v-model="model.employee_id"
					showSearch
					:options="employees"
					:filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
					:disabled="loading"
					class="ts-w-full"
				></a-select>
				<div class="validate" v-if="errors.has('employee_id')">
					{{ errors.first('employee_id') }}
				</div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'employeeLink',
  props: ['value', 'validate'],
  data() {
    return {
			errors: new Errors(),
      loading: false,
      employees: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.fetchEmployee()
  },
  methods: {
    fetchEmployee() {
      this.loading = true
      this.$store
        .dispatch('security/user/employee')
        .then(response => {
          this.employees = response.data.map(el => ({
						value: el.employee_id,
						label: el.employee_name_en
					}))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
	},
	watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
#emp-group {
  min-height: 115px;
  max-height: 150px;
  overflow-y: scroll;
}
</style>